import React from 'react';

import { Skeleton } from '@material-ui/lab';

import Card from '../../../Card';
import BaseSkeleton from '../BaseSkeleton';

import { ChatSupportSkeletonProps } from './ChatSupportSkeleton.types';

const ChatSupportSkeleton: React.FC<ChatSupportSkeletonProps> = ({
  className
}) => {
  return (
    <Card className={`relative flex flex-justify pl4 ${className}`}>
      <BaseSkeleton width={200} height={40} />
      <Skeleton variant="rect" width={130} height={40} />
    </Card>
  );
};

export default ChatSupportSkeleton;
export { ChatSupportSkeletonProps };
